module.exports = __webpack_public_path__ + "static/media/school_img.383f25e8.jpg";